import { ActionTree } from 'vuex';
import { UserInfo, UserState } from './state';
import RootState from '@/store/root_state';
import { query, MicroserviceEnum, mutation } from '@/helpers/westeros';
import { getUser, GetUserQueryResult } from '@/store/graphql/queries/westerosQueries';
import { upsertUser, UpsertUserMutationResult } from '@/store/graphql/mutations/westerosMutations';

const actions: ActionTree<UserState, RootState> = {
  async UPSERT_USER({ commit }, payload: { user: UserInfo }): Promise<void> {
    const variables = {
      fullName: payload.user.name,
      email: payload.user.email,
      phone: payload.user.phone,
      signupMethod: payload.user.signupMethod,
      accountId: payload.user.accountId,
    };

    try {
      const { data } = await mutation<UpsertUserMutationResult>(
        MicroserviceEnum.ADMISSIONS,
        upsertUser,
        variables,
      );

      const user: UserInfo = {
        id: data?.upsertUser.id,
        name: data?.upsertUser.fullName,
        email: data?.upsertUser.email,
        phone: data?.upsertUser.phone,
        signupMethod: data?.upsertUser.signupMethod,
        accountId: data?.upsertUser.accountId,
      };

      commit('SET_USER', user);
    } catch {
      throw new Error();
    }
  },

  async GET_USER(
    { commit },
    payload: { email: string; phone: string; shouldAuthorize?: boolean },
  ): Promise<void> {
    const variables = { email: payload.email || undefined, phone: payload.phone || undefined };

    try {
      const { data } = await query<GetUserQueryResult>(
        MicroserviceEnum.ADMISSIONS,
        getUser,
        variables,
      );

      const user: UserInfo = {
        id: data.getUser.id,
        name: data.getUser.fullName,
        email: data.getUser.email,
        phone: data.getUser.phone,
        signupMethod: data.getUser.signupMethod,
      };

      commit('SET_USER', user);
    } catch {
      throw new Error();
    }
  },
};

export default actions;
